import { FeedbackProps } from '../../pages/PerformanceReview/types';
import {
  Feedback,
  FeedbackStatusTypes,
} from '../../pages/PerformanceReview/Reviews/types';
import { mapFeedback } from '../../pages/PerformanceReview/Reviews/mappings';
import { RecipientEmployee } from '../../components/PastPerformanceReviewCard/types';
import { mapToRecipientEmployee } from '../../pages/PerformanceReview/EmployeePerformanceReview/EmployeeFeedbacks/NextPerformanceReview/mappings';
import { mapPeerFeedbacks } from '../../pages/PerformanceReview/EmployeePerformanceReview/EmployeeEvaluation/mapping';
import { PeerFeedback } from '../../pages/PerformanceReview/EmployeePerformanceReview/EmployeeEvaluation/types';

export type ManagerFeedbackItem = Feedback & {
  peerReviewers: RecipientEmployee[];
  peerFeedbacksMapped: PeerFeedback[];
  withPeers: boolean;
  maxPeers: number;
  outcomeId: string;
  currentFeedbackRequestId: string;
  revieweeId: string;
};

export const mapManagerFeedback = (
  feedback: FeedbackProps,
): ManagerFeedbackItem => ({
  ...mapFeedback(feedback),
  peerReviewers: feedback.peerFeedbacks.map((p) =>
    mapToRecipientEmployee(p.reviewer),
  ),
  peerFeedbacksMapped: mapPeerFeedbacks(feedback.peerFeedbacks),
  withPeers: feedback.feedbackCycle.flair__With_Peers__c ?? false,
  maxPeers: feedback.feedbackCycle.flair__Number_of_Peers__c ?? 0,
  outcomeId: feedback.outcome.Id,
  currentFeedbackRequestId: feedback.Id,
  revieweeId: feedback.reviewee.Id,
});

const STATUS_PRIORITY: Record<FeedbackStatusTypes, number> = {
  [FeedbackStatusTypes.Meeting]: 0,
  [FeedbackStatusTypes.InProgress]: 1,
  [FeedbackStatusTypes.NotStarted]: 2,
  [FeedbackStatusTypes.Completed]: 3,
};

export const sortManagerFeedbacks = (
  feedbacks: ManagerFeedbackItem[],
): ManagerFeedbackItem[] =>
  [...feedbacks].sort((a, b) => {
    const statusDiff =
      (STATUS_PRIORITY[a.status] ?? 4) - (STATUS_PRIORITY[b.status] ?? 4);
    if (statusDiff !== 0) return statusDiff;

    if (a.dueDate && b.dueDate)
      return a.dueDate.getTime() - b.dueDate.getTime();
    if (a.dueDate) return -1;
    if (b.dueDate) return 1;
    return 0;
  });
